import { z } from "zod";
import { nonNegativeMoneySchema, quantitySchema, rateSchema, uuidSchema } from "../common/primitives.js";
import { shortagePolicySchema } from "./enums.js";
/**
 * Vardiya ayarları (Prompt 13). Satır ŞİRKET düzeyindedir; `stationId` doluysa o istasyon için geçersiz kılmadır.
 * Hiçbir eşik koda gömülmez (AGENTS.md §3.12): tümü bu tablodan okunur ve "doğrulanmalı" (`needsVerification`)
 * olarak sunulur — yasal dayanağı yoktur.
 */
const settingsFields = {
    differenceToleranceAmount: nonNegativeMoneySchema.describe("Fark toleransının mutlak alt sınırı (kuruş)"),
    differenceTolerancePerMille: rateSchema.describe("Fark toleransı (‰, beklenen tutarın binde kaçı)"),
    shortagePolicy: shortagePolicySchema,
    chargeWithinTolerance: z.boolean().describe("Tolerans İÇİ açık da personele yazılsın mı"),
    allowOpenWithPreviousUnclosed: z
        .boolean()
        .describe("Önceki vardiya kapanmadan yeni vardiya açılabilsin mi (gerekçe zorunlu)"),
    openingTotalizerToleranceL: quantitySchema.describe("Elle girilen açılış endeksinin son okumadan sapabileceği sınır (L); üstü gerekçe ister"),
    transactionMismatchL: quantitySchema.describe("Endeks ↔ işlem litre farkı uyarı eşiği (L)"),
    defaultOpeningFloat: nonNegativeMoneySchema.describe("Varsayılan devir parası (kuruş)"),
    requireTankClosingReadings: z.boolean().describe("Gün sonunda tank kapanış okuması zorunlu mu"),
    tankClosingReadingWindowMinutes: z.number().int().min(5).max(1440),
    requireZReports: z.boolean().describe("Gün sonunda Z raporu zorunlu mu"),
    zMismatchThreshold: nonNegativeMoneySchema.describe("Z raporu ↔ sistem farkı alarm eşiği (kuruş)"),
    blockOnZMismatch: z.boolean().describe("Z farkı eşiği aşarsa gün sonu engellensin mi"),
    zCompareExcludesCreditSales: z
        .boolean()
        .describe("Z karşılaştırmasında veresiye / filo (faturalı) satışlar sistem tutarından düşülsün mü"),
    enforceDayOrder: z.boolean().describe("Gün sonları sırayla kapatılsın mı"),
    openShiftAlertHours: z.number().int().min(1).max(72).describe("Açık kalan vardiya alarmı (saat)"),
};
export const shiftSettingsSchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema.nullable().describe("Dolu ise bu istasyona özel geçersiz kılma"),
    /** true → kayıt YOKTUR; dönen değerler ürün varsayılanıdır (ilk PUT satırı oluşturur). */
    isDefault: z.boolean(),
    ...settingsFields,
    needsVerification: z.boolean().describe("Değerler mali müşavir / işletme tarafından doğrulanmalı"),
    version: z.number().int().min(0).describe("İyimser kilit sürümü; 0 = henüz kaydedilmemiş"),
});
/**
 * PUT ile TAMAMI değiştirilir (kısmi güncelleme yok) — bu yüzden adı `save…`'dir: `update…` adlı şemalar
 * `common/patch.test.ts` korumasına girer ve varsayılan içeren alanlarda kırılır.
 */
export const saveShiftSettingsSchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema.nullable().optional().describe("Verilirse istasyon geçersiz kılması yazılır"),
    ...settingsFields,
    needsVerification: z.boolean().optional(),
    version: z.number().int().min(0).describe("Okunan sürüm; 0 = kayıt yoktu"),
});
export const shiftSettingsQuerySchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema.optional().describe("Verilirse istasyonun ETKİN ayarı (yoksa şirket satırı) döner"),
});
//# sourceMappingURL=settings.js.map